import React, { useCallback, useState } from 'react';
import fastpanel from '../utils/fastpanel';

function useFirstInput(initialValue: string | string[]) {
  const [firstType, setFirstType] = useState<boolean>(true);
  const [inputValue, setInputValue] = useState<string | string[]>(initialValue);

  const onInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const searchText = e.target.value;
      if (firstType && searchText.length > 0) {
        setFirstType(false);
        fastpanel({ name: 'search_text_input' });
      }
      setInputValue(searchText);
    },
    [firstType]
  );

  return { onInputChange, inputValue, setInputValue };
}

export default useFirstInput;
